export default "__VITE_ASSET__3b1b20fb__"